import animationData from '~/assets/lotties/ch-loader.json';
import { Lottie } from '~/components/lottie-web/Lottie';
import { cn } from '~/lib/utils';

const loaderSize = {
  small: 'size-5',
  medium: 'size-9',
  large: 'size-[100px]',
} as const;

type Props = {
  size?: keyof typeof loaderSize;
};

export default function ConduitHealthLoader({ size = 'medium' }: Props) {
  return (
    <Lottie
      animationData={animationData}
      className={cn('aspect-square cursor-default', loaderSize[size])}
    />
  );
}
